import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GetEnrolledCourses from "../../actions/GetEnrolledCourses";
import { AuthContext } from "../../context/AuthContext";
import Localbase from "localbase";
import SetPage from "../../data/SetPage";
import { Skeleton } from "@mui/material";
import { Helmet } from "react-helmet";
import "./MyCourses.css";
import ENDPOINT from "../../data/ENDPOINT";

const MyCourses = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { user } = useContext(AuthContext);
  const [mycourses, setmycourses] = useState(null);
  let db = new Localbase("db");
  const NewGetMyCourses = async () => {
    const res = await GetEnrolledCourses({ user, limit: 20 });
    if (res) {
      setloading(false);
      if (res.status === "success") {
        db.collection("paths").add(
          {
            enrolled_courses: res.data,
          },
          "enrolled_courses",
        );
        setmycourses(res.data);
      }
    }
  };
  useEffect(() => {
    SetPage("My Courses");

    db.collection("paths")
      .doc("enrolled_courses")
      .get()
      .then((data) => {
        setmycourses(data.enrolled_courses);
      })
      .catch((error) => {});
    NewGetMyCourses({ user });
  }, []);

  const [loading, setloading] = useState(true);
  return (
    <div className="mycourses-wrapper">
      <style>{`
        @media (max-width: 767px) {
          .mycourses-wrapper {
            /* clear the fixed header (~60px) + a neat gap */
            padding-top: 76px !important;
          }
        }
      `}</style>
      <Helmet>
        <title>My Courses - SiliconMinds</title>
        <meta
          name="description"
          content="View your enrolled courses on SiliconMinds and continue learning"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@skillsuprise" />
        <meta name="twitter:creator" content="@skillsuprise" />
        <meta name="twitter:title" content="My Courses - Skills Uprise" />
        <meta
          name="twitter:description"
          content="View your enrolled courses and track your progress"
        />
        <meta property="og:title" content="My Courses" />
        <meta
          property="og:description"
          content="Continue your learning journey with Skills Uprise"
        />
        <meta property="og:site_name" content="Skills Uprise" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="mycourses-container">
        {/* Header Section */}
        {/* <div className="mycourses-header">
          <div className="header-content">
            <h1 className="header-title">My Learning Journey</h1>
            <p className="header-subtitle">Continue where you left off and track your progress</p>
          </div>
        </div> */}

        {/* Courses Grid */}
        {mycourses ? (
          <>
            {mycourses.length > 0 ? (
              <div className="courses-grid mt-2">
                {mycourses.map((course) => (
                  <div key={course.course_url} className="course-card-wrapper">
                    <Link
                      to={
                        "/course-dashboard/" +
                        course.course_url +
                        "/" +
                        course.batch_id
                      }
                      className="course-card-link"
                    >
                      <div className="course-card">
                        {/* Image Section */}
                        <div className="course-image-container">
                          <img
                            className="course-image"
                            src={course.course_cover}
                            alt={course.course_title}
                          />
                          <div className="course-overlay">
                            <div className="progress-indicator">
                              <div className="progress-ring">
                                <svg width="80" height="80" viewBox="0 0 80 80">
                                  <circle
                                    cx="40"
                                    cy="40"
                                    r="36"
                                    className="progress-bg"
                                  />
                                  <circle
                                    cx="40"
                                    cy="40"
                                    r="36"
                                    className="progress-bar"
                                    style={{
                                      strokeDasharray: `${(course.progress * 226) / 100} 226`,
                                    }}
                                  />
                                </svg>
                                <div className="progress-text">
                                  <span className="progress-percentage">
                                    {course.progress}%
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Course Info Section */}
                        <div className="course-info">
                          <h3 className="course-title">
                            {course.course_title}
                          </h3>

                          <div className="course-details">
                            <div className="detail-item">
                              <span className="detail-label">Student ID</span>
                              <span className="detail-value">
                                {course.student_id}
                              </span>
                            </div>
                            <div className="detail-item">
                              <span className="detail-label">Batch</span>
                              <span className="detail-value">
                                {course.batch_id}
                              </span>
                            </div>
                          </div>

                          <div className="course-details">
                            <div className="detail-item">
                              <span className="detail-label">Team</span>
                              <span className="detail-value">
                                {course.team_id}
                              </span>
                            </div>
                            <div className="detail-item">
                              <span className="detail-label">Progress</span>
                              <span className="detail-value progress-value">
                                {course.progress}%
                              </span>
                            </div>
                          </div>

                          {/* <div className="progress-bar-container">
                            <div className="progress-track">
                              <div
                                className="progress-fill"
                                style={{ width: `${course.progress}%` }}
                              ></div>
                            </div>
                          </div> */}
                        </div>

                        {/* Action Button */}
                        <button className="course-action-btn">
                          <span>Go to Dashboard</span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                          >
                            <path d="M5 12h14M12 5l7 7-7 7" />
                          </svg>
                        </button>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            ) : (
              <div className="empty-state">
                <img
                  src={`${ENDPOINT}resources/images/no-courses.svg`}
                  alt="No courses"
                  className="empty-state-image"
                />
                <h3 className="empty-state-title">No Courses Yet</h3>
                <p className="empty-state-text">
                  Start your learning journey today
                </p>
                <Link to="/courses" className="btn-browse-courses">
                  Explore Courses
                </Link>
              </div>
            )}
          </>
        ) : (
          <>
            {loading ? (
              <div className="loading-skeleton-grid">
                {[1, 2, 3, 4, 5, 6].map((item) => (
                  <div key={item} className="skeleton-card">
                    <Skeleton
                      variant="rectangular"
                      height={220}
                      className="skeleton-image"
                    />
                    <div className="skeleton-content">
                      <Skeleton variant="text" height={24} width="80%" />
                      <Skeleton variant="text" height={16} width="60%" />
                      <Skeleton
                        variant="rectangular"
                        height={6}
                        className="skeleton-progress"
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="empty-state">
                <img
                  src={`${ENDPOINT}resources/images/no-courses.svg`}
                  alt="No courses"
                  className="empty-state-image"
                />
                <h3 className="empty-state-title">No Courses Yet</h3>
                <p className="empty-state-text">
                  Start your learning journey today
                </p>
                <Link to="/courses" className="btn-browse-courses">
                  Explore Courses
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MyCourses;